
export const CHECKOUT_LINK =
  "https://checkout.ebookpoint.shop/cart/59860630503505:1";

export const PRODUCT_IMAGE =
  "https://cdn.magicpatterns.com/uploads/7wFJZJ2HwjmnNbSXtQrj7n/ChatGPT_Image_Jul_24,_2026,_04_04_44_PM.png";

export const FIELD_BG =
  "https://cdn.magicpatterns.com/patterns/generated-images/87dd830a-9ffd-4932-af78-a646bb1895e1.jpg";

export type Module = {
  emoji: string;
  title: string;
  items: string[];
  highlight?: string;
};

export const CATEGORIES: { label: string; modules: Module[] }[] = [
  {
    label: "CATEGORÍA 1 — Baby Fútbol (5-8 años)",
    modules: [
      {
        emoji: "👟",
        title: 'Tomo 1 — "Los primeros pasos: metodología y entrenamiento en baby fútbol"',
        items: [
          "El juego como único contenido",
          "Motricidad y lateralidad",
          "Estructura de sesión para esta edad",
          "Errores típicos: qué no enseñar todavía",
          "Reglamento de baby fútbol",
        ],
      },
      {
        emoji: "🤗",
        title: 'Tomo 2 — "Contené sin frenar: psicología y padres en baby fútbol"',
        items: [
          "Motivación a esta edad",
          "Feedback apropiado para 5-8 años",
          "Primera reunión de padres",
          'El padre "DT" desde el arranque',
          "Planilla de asistencia y seguimiento inicial",
        ],
      },
    ],
  },
  {
    label: "CATEGORÍA 2 — Infantiles (9-12 años)",
    modules: [
      {
        emoji: "🎯",
        title: 'Tomo 3 — "La ventana técnica: metodología y entrenamiento en infantiles"',
        items: [
          "Técnica individual: ventana sensible",
          "Estructura de sesión y planificación",
          "Juego reducido como herramienta",
          "Iniciación táctica temprana",
          "Reglamento por categoría",
        ],
      },
      {
        emoji: "🌱",
        title: 'Tomo 4 — "El grupo crece: gestión y padres en infantiles"',
        items: [
          "Autoestima deportiva y error",
          "El jugador que no juega",
          "Minutos de juego: cómo comunicarlos",
          "WhatsApp de padres y conflictos",
          "Ficha de evaluación de jugador",
        ],
      },
    ],
  },
  {
    label: "CATEGORÍA 3 — Cadetes (13-14 años)",
    modules: [
      {
        emoji: "💪",
        title: 'Tomo 5 — "Pubertad y método: entrenamiento en cadetes"',
        items: [
          "Cambios de coordinación en pubertad",
          "Iniciación a la fuerza general",
          "Primeros esquemas tácticos",
          "Prevención de lesiones (Osgood-Schlatter, etc.)",
          "Planificación de sesión y microciclo",
        ],
      },
      {
        emoji: "🧠",
        title: 'Tomo 6 — "Adolescencia en cancha: gestión y padres en cadetes"',
        items: [
          "Frustración y liderazgo del entrenador",
          "Comunicación de objetivos del proceso",
          "Conflictos entre padres",
          "Documentación y pases entre clubes",
          "Armado de equipos equilibrados",
        ],
      },
    ],
  },
  {
    label: "CATEGORÍA 4 — Juveniles y Tercera División (15-16 años)",
    modules: [
      {
        emoji: "🏆",
        title: 'Tomo 7 — "Exigencia real: metodología y entrenamiento en juveniles/tercera"',
        items: [
          "Especialización y sistemas de juego",
          "Pretemporada semana a semana",
          "Físico competitivo: fuerza, velocidad, resistencia",
          "Prevención de isquios y rodilla en competencia",
          "Análisis básico de rival",
        ],
      },
      {
        emoji: "🚀",
        title: 'Tomo 8 — "El salto a la exigencia: gestión y profesionalización"',
        highlight: "+480 Páginas de contenido, hechas para que puedas aprovechar tu tiempo libre",
        items: [
          "Burnout y sobreentrenamiento",
          "Liderazgo con jugadores casi adultos",
          "Fair play y conducta en torneos",
          "Aspectos administrativos de club chico",
          "Seguimiento de lesiones y planificador semanal",
        ],
      },
    ],
  },
];

export type Bonus = {
  emoji: string;
  title: string;
  desc: string;
  image?: string;
};

export const BONUSES: Bonus[] = [
  {
    emoji: "📊",
    title: "1 - Kit de Planillas de Gestión",
    desc: "Asistencia, evaluación de jugador, armado de equipos, seguimiento de lesiones, planificador semanal.",
    image:
      "https://cdn.magicpatterns.com/uploads/eFutAwjAfsbCR9BMw7tYUn/ChatGPT_Image_Jul_24,_2026,_11_43_44_PM.png",
  },
  {
    emoji: "⚽",
    title: "2 - Banco de Ejercicios por Categoría",
    desc: "20 ejercicios con diagrama de cancha, por edad y objetivo.",
    image:
      "https://cdn.magicpatterns.com/uploads/9pYkmvmqk9VDeF8MsZe5wW/ChatGPT_Image_Jul_24,_2026,_11_43_49_PM.png",
  },
  {
    emoji: "💬",
    title: "3 - Plantillas de Comunicación con Padres",
    desc: "Guión de reunión, mensajes tipo, carta de objetivos, protocolo de conflicto.",
    image:
      "https://cdn.magicpatterns.com/uploads/8Ah1VS3ZLVgRuRw2E15yMy/ChatGPT_Image_Jul_24,_2026,_11_43_51_PM.png",
  },
  {
    emoji: "📅",
    title: "4 - Planificador Anual con 52 Sesiones",
    desc: "Calendario macro + sesión completa por semana, 8 fases de periodización.",
    image:
      "https://cdn.magicpatterns.com/uploads/ne85oe3NUEmQk7opYiJeWR/ChatGPT_Image_Jul_24,_2026,_11_43_53_PM.png",
  },
  {
    emoji: "🩹",
    title: "5 - Guía de Prevención de Lesiones por Edad",
    desc: "9 fichas de lesiones típicas + protocolo de retorno en 5 fases.",
    image:
      "https://cdn.magicpatterns.com/uploads/pKfHkoQ6skq3TysEjqCeeS/ChatGPT_Image_Jul_24,_2026,_11_43_54_PM.png",
  },
  {
    emoji: "⚡",
    title: "6 - Manual de Corrección Rápida",
    desc: '16 situaciones "si ves esto, corregí así".',
    image:
      "https://cdn.magicpatterns.com/uploads/6YDc8mbsYAnWEGBfqZMinr/ChatGPT_Image_Jul_24,_2026,_11_46_31_PM.png",
  },
];

export const PROBLEMS: string[] = [
  "Pasás horas armando cada sesión desde cero y nunca te alcanza el tiempo.",
  "No sabés qué contenido corresponde a cada edad y terminás improvisando.",
  "Los padres te desbordan con mensajes y conflictos que no sabés cómo manejar.",
  "Copiás ejercicios sueltos de internet sin una progresión que tenga sentido.",
  "Llegás quemado al entrenamiento y sentís que no estás formando de verdad.",
];

export type MailReview = {
  name: string;
  email: string;
  subject: string;
  preview: string;
  time: string;
};

export const MAIL_REVIEWS: MailReview[] = [
  {
    name: "Marcos Gutiérrez",
    email: "marcosgtz@gmail.com",
    subject: "Gracias, me salvaste la temporada",
    preview:
      "Profe, tenía que armar baby, infantiles y cadetes y no daba más. Con esto ya tengo todo el año resuelto. Lo recomiendo 100%.",
    time: "9:14",
  },
  {
    name: "Lucía Fernández",
    email: "luciafdez.dt@gmail.com",
    subject: "Las planillas son un golazo",
    preview:
      "Lo mejor fueron las planillas de gestión y el planificador anual. Ordené todo el club en un fin de semana. Increíble.",
    time: "ayer",
  },
  {
    name: "Diego Sosa",
    email: "diegososa87@gmail.com",
    subject: "Justo lo que necesitaba",
    preview:
      "Soy profe de tercera y el tomo de juveniles es muy completo. La prevención de lesiones sola ya vale el precio.",
    time: "mar",
  },
  {
    name: "Pablo Romero",
    email: "pabloromero.futbol@gmail.com",
    subject: "Ahorré muchísimo tiempo",
    preview:
      "Antes tardaba toda la semana en planificar. Ahora abro el banco de ejercicios y listo. Se los recomiendo a todos los colegas.",
    time: "lun",
  },
];

export type StarReview = {
  name: string;
  location: string;
  text: string;
};

export const STAR_REVIEWS: StarReview[] = [
  {
    name: "Hernán Quiroga",
    location: "Rosario, Santa Fe",
    text: "Impecable. Todo bien explicado y aplicable en cancha desde el primer día. Me sacó un peso de encima.",
  },
  {
    name: "Sofía Medina",
    location: "Córdoba Capital",
    text: "Los diagramas de ejercicios son buenísimos y las plantillas para hablar con los padres me salvaron un montón de líos.",
  },
  {
    name: "Ariel Benítez",
    location: "La Plata, Buenos Aires",
    text: "Muy completo para el precio. Lo uso para infantiles y cadetes y me organizó toda la pretemporada.",
  },
  {
    name: "Gastón Ferreyra",
    location: "Mendoza",
    text: "Entrega inmediata, todo en PDF, súper prolijo. Se nota que lo armó gente que estuvo en el barro del club.",
  },
];

export type Testimonial = {
  name: string;
  age: number;
  role: string;
  location: string;
  text: string;
};

export const TESTIMONIALS: Testimonial[] = [
  {
    name: "Julián Acosta",
    age: 34,
    role: "Coordinador de inferiores",
    location: "San Justo, Buenos Aires",
    text: "Manejo tres categorías en el club del barrio. Esto me dio un método claro y dejé de improvisar los lunes a la noche.",
  },
  {
    name: "Matías Ledesma",
    age: 41,
    role: "DT de baby fútbol",
    location: "Godoy Cruz, Mendoza",
    text: "Con los más chicos siempre me costaba saber qué enseñar. El Tomo 1 me ordenó la cabeza. Los pibes disfrutan más.",
  },
  {
    name: "Nicolás Vega",
    age: 28,
    role: "Profe de infantiles",
    location: "Bahía Blanca",
    text: "El planificador anual con las 52 sesiones es oro. Ya no arranco de cero cada semana.",
  },
  {
    name: "Federico Ríos",
    age: 46,
    role: "Entrenador de cadetes",
    location: "Resistencia, Chaco",
    text: "La parte de manejo de padres y adolescentes me sirvió muchísimo. Bajé un montón los conflictos en el grupo.",
  },
  {
    name: "Emiliano Paz",
    age: 37,
    role: "DT de tercera división",
    location: "Neuquén Capital",
    text: "El bloque de prevención de isquios y rodilla lo apliqué ya en pretemporada. Menos lesiones, más equipo entrenando.",
  },
];

export type Objection = { q: string; a: string };

export const OBJECTIONS: Objection[] = [
  {
    q: "¿Y si no tengo tiempo de leer 8 tomos?",
    a: "No hace falta leer todo de una. Vas directo a la categoría que estás dirigiendo y usás las planillas y el banco de ejercicios desde el primer día.",
  },
  {
    q: "Soy nuevo entrenando, ¿me va a servir?",
    a: "Sí. Está pensado para llevarte de la mano etapa por etapa, sin tener que aprenderlo a los golpes. Ideal para arrancar con método.",
  },
  {
    q: "¿Cómo lo recibo?",
    a: "Es 100% digital en PDF. Apenas comprás, recibís todo de forma inmediata en tu correo. Sin envíos ni esperas.",
  },
  {
    q: "¿Puedo usarlo en el celular?",
    a: "Claro. Los PDF se abren en cualquier celular, tablet o compu. Lo tenés a mano al costado de la cancha.",
  },
  {
    q: "¿Y si no me convence?",
    a: "Escribinos y te ayudamos. Nuestro soporte por mail responde todas tus dudas antes y después de la compra.",
  },
];

export const AR_NAMES: string[] = [
  "Martín", "Lucas", "Santiago", "Nicolás", "Facundo", "Agustín", "Tomás",
  "Julián", "Matías", "Federico", "Gonzalo", "Emiliano", "Diego", "Pablo",
  "Sofía", "Camila", "Valentina", "Lucía", "Florencia", "Micaela",
];

export const AR_CITIES: string[] = [
  "Rosario", "Córdoba", "La Plata", "Mar del Plata", "Mendoza", "San Juan",
  "Salta", "Tucumán", "Neuquén", "Bahía Blanca", "Resistencia", "Posadas",
  "Santa Fe", "Paraná", "San Luis", "Río Cuarto", "Quilmes", "Avellaneda",
  "Lanús", "Morón",
];
